export class IntegrationImage {
    public id: number;
    public integrationId?: number;
    public name?: string;
    public fileName?: string;
    public oroginalFileName?: string;
    public hash?: string;

    constructor(
        id: number, 
        /*email: string, 
        report: number,
        error: number,
        alert: number,
        rekbot_id?: number*/
        ) {
        this.id = id;
        /*this.email = email;
        this.report = report;
        this.error = error;
        this.alert = alert;
        this.rekbot_id = rekbot_id;*/
    }
}